module.exports = __webpack_public_path__ + "static/timetravel_img3jpg-82300a899365aa991cc12be559d05534.png";